module.exports = __webpack_public_path__ + "images/emoji/two_hearts.2e3c7f933b6231392507.png";